module.exports = __webpack_public_path__ + "img/bgtop3x.d327ee92.png";